import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME } from 'Common/FormEnum';

import { validateTruckScheduleData } from './../../helper';
import CreateEditTruckRouteScheduleComponent from '../../components/createedittruckrouteschedule/CreateEditTruckRouteSchedule';

class CreateEditTruckRouteScheduleContainer extends Component {
  static propTypes = {
    getBreadCrumbs: PropTypes.func,
    getMainProps: PropTypes.func,
    truckRouteListData: PropTypes.array,
    truckRouteListDataLoading: PropTypes.bool,
    onSubmit: PropTypes.func,
    truckRouteScheduleDetailData: PropTypes.object,
    isNewEdit: PropTypes.bool,
  };

  static defaultProps = {
    getBreadCrumbs: () => {},
    getMainProps: () => {},
    truckRouteListData: [],
    truckRouteListDataLoading: false,
    onSubmit: () => {},
    truckRouteScheduleDetailData: null,
    isNewEdit: false,
  };

  render() {
    const {
      getBreadCrumbs,
      getMainProps,
      truckRouteListData,
      truckRouteListDataLoading,
      onSubmit,
      truckRouteScheduleDetailData,
      isNewEdit,
    } = this.props;

    return (
      <CreateEditTruckRouteScheduleComponent
        getBreadCrumbs={getBreadCrumbs}
        getMainProps={getMainProps}
        truckRouteListData={truckRouteListData}
        truckRouteListDataLoading={truckRouteListDataLoading}
        onSubmit={onSubmit}
        truckRouteScheduleDetailData={truckRouteScheduleDetailData}
        isNewEdit={isNewEdit}
      />
    );
  }
}

export const CreateEditTruckRouteSchedule = reduxForm({
  form: CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateTruckScheduleData,
  enableReinitialize: true,
})(CreateEditTruckRouteScheduleContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/createedittruckrouteschedule/CreateEditTruckRouteSchedule.js